<template>
  <div class="asc-mx-rec-support-info-grid--wrapper">
    <div
      v-for="(grid, index) in getGrids"
      :key="`asc-mx-rec-support-info-grid--${type.name}-${
        !isEditable || isMxRecEditPermission ? 'noEdit' : 'edit'
      }-${index}`"
      class="asc-mx-rec-support-info-grid--container"
    >
      <div
        v-if="getGridTitle(grid)"
        class="asc-mx-rec-support-info-grid--container-title"
      >
        {{ getGridTitle(grid) }}
      </div>
      <v-lazy
        v-model="isActive"
        :options="{
          threshold: 0.5,
        }"
        transition="expand-transition"
      >
        <asc-vision-grid
          :id="`asc-mx-rec-support-info-grid--${type.name}`"
          :key="`asc-mx-rec-support-info-grid--${type.name}-${
            !isEditable || isMxRecEditPermission ? 'noEdit' : 'edit'
          }`"
          :is-editable="isEditable"
          :disabled="disabled"
          :selected-rows="getGridSelections"
          :page-size-selected="defaultPageSizeSelected"
          :page-sizes="defaultPageSizes"
          :show-eyeball-column="showEyeballColumn"
          :read-only-eyeball-column="readOnlyEyeballColumn"
          :column-defs="getGridColumnDefs(grid)"
          :values="getGridRowData(grid)"
          :grid-filters="hasGridFilters(grid)"
          :get-row-id="params => params.data.rowId"
          @onRowSelected="handleRowSelected"
        ></asc-vision-grid>
      </v-lazy>
    </div>
    <asc-caption
      v-if="
        hasCaptionOption &&
        ((isEditPermissionInvestigate && !isRecommendationTab && isEditable) ||
          disabled)
      "
      :class="{
        'asc-mx-rec-support-info-grid--wrapper-disabled-caption': disabled,
      }"
      :caption="previewCaption"
      :disabled="disabled"
      :max-length="500"
      @blur="handlePreviewCaptionUpdate"
    ></asc-caption>
    <p
      v-if="
        hasCaptionOption &&
        (!isEditable ||
          (isReadOnlyPermissionInvestigate && !isRecommendationTab)) &&
        !disabled
      "
      class="asc-mx-rec-support-info-grid--wrapper-attachment-caption mb-0"
    >
      {{ previewCaption }}
    </p>
  </div>
</template>

<script>
import AscCaption from '../molecules/AscCaption.vue'
import AscVisionGrid from '../molecules/AscVisionGrid.vue'

import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import AscMxRecSupportInfoGridWrapperMixin from '../mixins/AscMxRecSupportInfoGridWrapperMixin.vue'

export default {
  name: 'AscMxRecSupportInfoGridWrapper',

  components: {
    AscVisionGrid,
    AscCaption,
  },

  mixins: [
    AscMxRecPropsMixin,
    AscMxRecSupportInfoGridWrapperMixin,
    AscMxRecPermissionMixin,
  ],
  props: {
    isRecommendationTab: {
      type: Boolean,
    },
  },
  data: () => ({
    isActive: false,
  }),

  created: function () {
    this.selectedRows = this.getGridSelections
  },

  methods: {
    handleRowSelected(rowNode) {
      this.$emit('onRowSelected', {
        type: this.type,
        row: rowNode,
      })

      if (rowNode.selected) {
        this.selectedRows.push(rowNode.data)
      } else {
        // if the user deslected it,
        // remove it from the selected rows array
        this.selectedRows = this.selectedRows.filter(rowObj => {
          return rowObj.id !== rowNode.data.id
        })
      }

      if (
        this.selectedRows &&
        !this.selectedRows.length &&
        !this.visibilityReminderSent
      ) {
        // need to alert the user that all items are off
        this.$emit('onVisibilityReminder', this.getSectionTitle)
        // flip the state for the toggle reminder so this would only happen on the
        // first time
        this.visibilityReminderSent = true
      }
      if (
        this.selectedRows &&
        this.selectedRows.length &&
        !this.visibilityConfirmationSent
      ) {
        // need to alert the user that all items are off
        this.$emit('onVisibilityConfirmation', this.getSectionTitle)
        // flip the state for the toggle reminder so this would only happen on the
        // first time
        this.visibilityConfirmationSent = true
      }
    },
  },
}
</script>

<style lang="scss">
.asc-mx-rec-support-info-grid--wrapper {
  .asc-mx-rec-support-info-grid--container {
    margin-bottom: 16px;
    width: 100%;

    &-title {
      display: inline-block;
      padding: 12px 8px 12px 8px;
      background: $gray-300;
      width: 100%;
      flex: 1 1 auto;
    }
  }
}
</style>
